// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kF-z","twoColumnImage":"lF-z"};